/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './UserCapacityLimitsV2Service';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#upsertTotalTicketCapacityLimits
 */
export const UPSERT_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_upsertTotalTicketCapacityLimits';
export const UPSERT_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME,
  args: ['userCapacityLimits'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.upsertTotalTicketCapacityLimitsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#upsertTicketCapacityLimits
 */
export const UPSERT_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_upsertTicketCapacityLimits';
export const UPSERT_TICKET_CAPACITY_LIMITS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME,
  args: ['userCapacityLimits'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.upsertTicketCapacityLimitsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#deleteTotalTicketCapacityLimits
 */
export const DELETE_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_deleteTotalTicketCapacityLimits';
export const DELETE_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_TOTAL_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME,
  args: ['userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.deleteTotalTicketCapacityLimitsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#deleteTicketCapacityLimits
 */
export const DELETE_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_deleteTicketCapacityLimits';
export const DELETE_TICKET_CAPACITY_LIMITS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_TICKET_CAPACITY_LIMITS_MUTATION_FIELD_NAME,
  args: ['userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deleteTicketCapacityLimitsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#getCapacityEligibleTeams
 */
export const GET_CAPACITY_ELIGIBLE_TEAMS_QUERY_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_getCapacityEligibleTeams';
export const GET_CAPACITY_ELIGIBLE_TEAMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CAPACITY_ELIGIBLE_TEAMS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getCapacityEligibleTeamsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#getCurrentUserCapacityData
 */
export const GET_CURRENT_USER_CAPACITY_DATA_QUERY_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_getCurrentUserCapacityData';
export const GET_CURRENT_USER_CAPACITY_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURRENT_USER_CAPACITY_DATA_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getCurrentUserCapacityDataRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.UserCapacityLimitsV2Service#getUserCapacityData
 */
export const GET_USER_CAPACITY_DATA_QUERY_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_UserCapacityLimitsV2Service_getUserCapacityData';
export const GET_USER_CAPACITY_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_CAPACITY_DATA_QUERY_FIELD_NAME,
  args: ['userId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getUserCapacityDataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});